export function acSessionParams(val) {
    return {
        type: 'SESSION_PARAMS',
        payload: val
    }

}
